import * as React from 'react';
import { Dispatch } from 'react-redux';

import { PreviewPageWrapper } from '../styles';
import Utils from '../../../../utils';
import { createNotification } from '../../../../containers/NotificationBar/actions';
import { StoreState } from '../../../../reducers';

interface PreviewPageProps {
	page: number;
	src: string;
	onLoad: () => void;
	dispatch: Dispatch<StoreState>;
}

const PreviewPage = ({ src, onLoad, dispatch }: PreviewPageProps) => {
	const [isError, setError] = React.useState(false);

	const handleError = async () => {
		setError(true);

		try {
			// call to this url will initiate a re-login in case session was expired
			const { status } = await Utils.promiseXHR('GET', src);
			if (status === 200) {
				setError(false);
			} else {
				dispatch(createNotification('error.fetch_editor_data_error'));
			}
		} catch (error) {
			dispatch(createNotification('error.fetch_editor_data_error'));
		}
	};

	if (isError) {
		return null;
	}

	return (
		<PreviewPageWrapper>
			<img
				src={src}
				onLoad={onLoad}
				onError={handleError}
			/>
		</PreviewPageWrapper>
	);
};

export default PreviewPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/PreviewPagesSpread/PreviewPage/index.tsx